import { render, staticRenderFns } from "./PaginationV2.vue?vue&type=template&id=0fefebfe&scoped=true&"
import script from "./PaginationV2.vue?vue&type=script&lang=ts&"
export * from "./PaginationV2.vue?vue&type=script&lang=ts&"
import style0 from "./PaginationV2.vue?vue&type=style&index=0&id=0fefebfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fefebfe",
  null
  
)

export default component.exports